import { FunctionComponent, useState } from 'react'
import styles from '../export.module.scss'
import { BrowserUpdated } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { ExportDataType } from '@/types/Export'
import { Daycare } from '@/types/Daycare'
import ExportDialog from '../exportDialog.tsx'

interface ExportAbsencesProps {
    daycares: Daycare[]
    isRpeOrLaep: boolean
    minDate: string
}

const ExportAbsences: FunctionComponent<ExportAbsencesProps> = ({
    daycares,
    isRpeOrLaep,
    minDate
}: ExportAbsencesProps) => {
    const { t } = useTranslation()

    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)

    return (
        <>
            <a className={styles.Case} onClick={(): void => setIsDialogOpen(true)}>
                <p className={styles.CaseTitle}>{t('absences')}</p>
                <BrowserUpdated className={styles.CaseIcon} />
            </a>
            {isDialogOpen && (
                <ExportDialog
                    type={ExportDataType.Absences}
                    open={isDialogOpen}
                    handleClose={(): void => setIsDialogOpen(false)}
                    daycares={daycares}
                    minDate={minDate}
                    isRpeOrLaep={isRpeOrLaep}
                />
            )}
        </>
    )
}

export default ExportAbsences
